import React from 'react';

const Base = ({ children }) => (

  <div className="accordion-item">
    {children}
  </div>
);

export default Base;
